// Internal Imports
import { API_ENDPOINTS, SETTINGS } from "../../constants";

// Destructuring
const { APIS } = API_ENDPOINTS;
const { CRM_SHORT_NAMES: crmIds } = SETTINGS;

// eslint-disable-next-line import/prefer-default-export
export const getCRMAuthURl = (crmConfig, orgID) => {
  const {
    client_id: clientID,
    client_secret: clientSecret,
    crm: crmID,
    redirect_url: redirectURL,
    is_sandbox: isSandbox,
  } = crmConfig;
  switch (crmID) {
    case crmIds.SALESFORCE: {
      const apiUrl = isSandbox ? APIS.SF_TEST_OAUTH2 : APIS.SF_LOGIN_OAUTH2;
      return `${apiUrl}?response_type=code&client_id=${clientID}&client_secret=${clientSecret}&redirect_uri=${redirectURL}&state=${orgID}&
    scope=full%20refresh_token`;
    }
    case crmIds.ZOHO:
      return `${
        APIS.ZH_OAUTH2
      }&client_id=${clientID}&response_type=code&access_type=offline&prompt=consent&redirect_uri=${redirectURL}&state=${orgID}`;
    case crmIds.DOCUSIGN:
      return `${APIS.DOC_SIGN}&client_id=${clientID}&redirect_uri=${
        crmConfig.redirectURL
      }`;
    default:
      return null;
  }
};



// WEBPACK FOOTER //
// ./src/actions/IntegrationsActions/IntegrationsMethods.js